import { Component, OnDestroy, OnInit } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import { switchMap, takeUntil, tap } from 'rxjs/operators';
import { IBreadcrumbItem } from 'src/app/interfaces/breadcrumb/breadcrumb.interface';
import { MessageService } from 'src/app/services/message/message.service';

@Component({
    selector: 'app-messages',
    templateUrl: './messages.component.html',
    styleUrls: ['./messages.component.scss'],
})
export class MessagesComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject();
    private update$ = new ReplaySubject();
    breadcrumb: IBreadcrumbItem[] = [
        {
            link: '',
            title: 'Messages',
        },
    ];
    loading = false;
    diagnosticResponse: any;

    constructor(private messageService: MessageService) {}

    ngOnInit() {
        this.update$
            .pipe(
                tap(() => (this.loading = true)),
                switchMap(() =>
                    this.messageService.getDiagnostic().pipe(
                        takeUntil(this.destroy$),
                        tap((res) => {
                            this.diagnosticResponse = res;
                            this.loading = false;
                        }),
                    ),
                ),
            )
            .subscribe();

        this.update$.next();
    }

    getDiagnostic() {
        this.update$.next();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
